module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0111.jpg?v=b5916208";